import React from 'react'
import styled from 'styled-components';
import UserInfoItem from './UserInfoItem'
import PriceBox from './PriceBox'

const proItemWidth = '540px';
const ProductPanelStyle = styled.div`
  display: flex;
  color: #2A2D35;
  .logo-img {
    margin-bottom: 30px;
    width: ${proItemWidth};
    max-height:${proItemWidth};
    >img {
      width: 100%;
      object-fit: cover;
      background-color: #ccc;
    }
  }
  .intro {
    margin-bottom: 30px;
    width: ${proItemWidth};
    padding-left: 50px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h2 {
      margin-bottom: 30px;
    }
    .intr-desc {
      font-size: 18px;
      color: #666666;
      line-height: 25px;
      margin: 25px 0;
    } 
  }
  @media (max-width: 768px) {
    display: block;
    .logo-img {
      width: 100%;
    }
    .intro {
      width: 100%;
      flex-basis: 100%;
      padding-left: 0;
    }
  }
`;


export default function ProductPanel() {
  return (
    <ProductPanelStyle>
      <div className="logo-img">
        <img src="https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2629006209,3888685974&fm=26&gp=0.jpg" alt=""/>
      </div>
      <div className="intro">
        <div>
          <h2 className="h2">Land of the Lost</h2>
          <UserInfoItem>owocki</UserInfoItem>
          <div className="intr-desc">
          Land of the Lost is a mysterious and dinosaur dominated land, whose borders are intertwined, so anyone who traveling towards one direction will end up in an endless cycle. The only way out is to compound metals extracted from particular mine to form a special weapon to disentangle the twisted world.
          </div>
        </div>
        <PriceBox>1.5</PriceBox>
      </div>
    </ProductPanelStyle>
  )
}
